import {
  Component,
  Input,
  Renderer2,
  TemplateRef,
  inject,
  viewChild,
} from '@angular/core';

import { DialogService, DownloadService } from '../../services';

@Component({
  selector: 'phoenix-downloads-management',
  templateUrl: './downloads-management.component.html',
  standalone: false,
})
export class DownloadsManagementComponent {
  downloadsManagementDialog = viewChild<TemplateRef<unknown>>(
    'downloadsManagementDialog'
  );

  @Input() expanded = false;
  downloadService = inject(DownloadService);
  dialogService = inject(DialogService);
  renderer = inject(Renderer2);

  progressIcon = `url("/assets/images/icons/downloads-management/export_progress.svg")`;
  cancellingDownloads = new Set<string>();

  openDownloadsPanel() {
    this.dialogService.info(
      this.downloadsManagementDialog() as TemplateRef<unknown>,
      {
        width: '700px',
        data: {
          showActions: true,
        },
      }
    );
  }

  deleteDownload(id: string): void {
    this.downloadService.removeDownload(id);
  }

  downloadElement(id: string): void {
    this.downloadService.downloadElement(id, this.renderer);
  }

  async cancelDownload(id: string): Promise<void> {
    this.cancellingDownloads.add(id);
    try {
      await this.downloadService.cancelDownload(id);
    } finally {
      this.cancellingDownloads.delete(id);
    }
  }

  isCancelling(id: string): boolean {
    return this.cancellingDownloads.has(id);
  }
}
